import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material'

import withStyles from '@mui/styles/withStyles'

import { requestActions } from 'state/request'

import type { ApplicationError, RequestError } from 'types'
import { APPLICATION_ERRORS } from 'qap/constants'

type RateLimitError = {
  retryAfter: number;
};

type Props = {
  errorCode: string | null | undefined;
  title: string | null | undefined;
  message: string | null | undefined;
  rateLimitError: RateLimitError | null | undefined;
  classes: any;
  noBackdrop?: boolean;
  clearRequestErrors: any;
  onClose?: any;
};

type DefaultAction = {
  action: {
    label: string;
    path?: string;
  };
};

const styles = (theme: any) => ({
  title: {
    fontFamily: theme.typography.caption.fontFamily
  },

  noBackdrop: {
    display: 'none'
  },
})

const DEFAULT_ACTION: DefaultAction = { action: { label: 'OK' } }

class ErrorDialog extends Component<Props> {
  handleClose = (event: any, reason: string) => {
    if(reason === 'backdropClick' || reason === 'escapeKeyDown'){
      return
    }

    const { clearRequestErrors, onClose } = this.props
    clearRequestErrors()
    onClose && onClose()
  }

  errorMessage = (error: ApplicationError): string => {
    let msg = error.message

    const { rateLimitError } = this.props
    if (rateLimitError) {
      const { retryAfter } = rateLimitError
      msg = msg.replace('{retryAfter}', retryAfter.toString())
    }

    return msg
  }

  actions = (error: ApplicationError | DefaultAction) => {
    const { action: { label, path } } = error
    let btnAction: Record<string, any> = {}

    if (path) {
      btnAction['href'] = path
    } else {
      btnAction['onClick'] = this.handleClose
    }

    return (
      <DialogActions>
        <Button variant='contained' color='secondary' {...btnAction}>
          { label }
        </Button>
      </DialogActions>
    )
  }

  render () {
    const { errorCode, noBackdrop, title, message, classes } = this.props
    if (!errorCode) return null
// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ '400': { description: string; title: string; message: string; action: { label: string; }; }; '403': { description: string; title: string; message: string; action: { label: string; }; }; '404': { description: string; title: string; message: string; action: { ...; }; }; ... 4 more ...; failed_to_fetch: { ...; }; }'.
    const error = APPLICATION_ERRORS[errorCode]
    if (!error && !title && !message) return null

    let dialogProps = {
      open: true,
      fullWidth: true,
      onClose: this.handleClose
    }

    if (noBackdrop) {
      dialogProps = {
        ...dialogProps,
// @ts-expect-error - TS2322 - Type '{ BackdropProps: { classes: { root: any; }; }; open: boolean; fullWidth: boolean; onClose: (event: any, reason: string) => void; }' is not assignable to type '{ open: boolean; fullWidth: boolean; onClose: (event: any, reason: string) => void; }'.
        'BackdropProps': {
          classes: {
            root: classes.noBackdrop
          }
        }
      }
    }

    return (
      <Dialog {...dialogProps}>
        <DialogTitle>
          <Typography variant='h6' className={classes.title} component='span'>
            { title || error.title }
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            { message || this.errorMessage(error) }
          </DialogContentText>
        </DialogContent>
        { this.actions(error || DEFAULT_ACTION) }
      </Dialog>
    )
  }
}

const rateLimitError = (e: RequestError): RateLimitError | null | undefined => {
  if (!Array.isArray(e.errors)) return
  const error = e.errors.find(err => err.status === '429')
  return error && error.meta
}

const mapStateToProps = (state: any, _: any) => {
  const {
    request: { errors }
  } = state
  if (errors && errors.length) {
    const error = errors[0]
    const { status: errorCode, title, message, onClose } = error

    return {
      errorCode,
      title,
      message,
      onClose,
      rateLimitError: rateLimitError(error)
    }
  }
  return {}
}

const mapDispatchToProps = {
  clearRequestErrors: requestActions.clearRequestErrors
} as const

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ErrorDialog)
)
